import { render, staticRenderFns } from "./GeneralProductStatementSelectModal.vue?vue&type=template&id=67d45c0f&"
import script from "./GeneralProductStatementSelectModal.vue?vue&type=script&lang=js&"
export * from "./GeneralProductStatementSelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports